import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EditAptContract from "./editAptContract";
import { locationPinCode,shipTolocationPinCode } from "services/redux/sales/corporate/locations/action";
import {getContractRevenue, postSalesEditApartmentLead, getContractService} from "services/redux/sales/postSales/action";
import { clientBillingAddress } from "services/redux/sales/corporate/client/action";
import {
  contractApartment,
  getMateriaById,
  getBrandById,
  getTagById,
} from "services/redux/sales/postSales/contractCorporate/action";
import {
  documentUploadUrl,
  imageUploadUrl,
  videoUploadUrl,
} from "services/redux/fileUpload/action";
import { supplyNameFun } from "services/redux/sales/corporate/categoryDetails/action";

const mapStateToProps = (state) => ({
  contractAptData: state.contractCorporateReducer.contractAptData,
  pincodeData: state.locationReducer.pincodeData,
  getMaterial: state.contractCorporateReducer.getMaterial,
  getBrand: state.contractCorporateReducer.getBrand,
  getTag: state.contractCorporateReducer.getTagById,
  documentUrlData: state.fileUploadReducer.documentUrlData,
  splNameData: state.categoryDetlReducer.splNameData,
  shipToPincodeData:  state.locationReducer.shipToPincodeData,
  clientBillingPocData: state.clientReducer.billingAddressPoc,
  contractRevenueDetails: state.postSalesReducer.contractRevenueDetails,
  contractCatService: state.postSalesReducer.contractCatService,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      contractApartment,
      locationPinCode,
      postSalesEditApartmentLead,
      getMateriaById,
      getBrandById,
      getTagById,
      documentUploadUrl,
      imageUploadUrl,
      videoUploadUrl,
      supplyNameFun,
      shipTolocationPinCode,
      clientBillingAddress,
      getContractRevenue,
      getContractService
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditAptContract);
